/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type { TokenObtainPair, TokenRefresh } from '../models/index';
import {
  TokenObtainPairFromJSON,
  TokenObtainPairToJSON,
  TokenRefreshFromJSON,
  TokenRefreshToJSON,
} from '../models/index';

export interface ApiJwtTokenCreateRequest {
  tokenObtainPair: Omit<TokenObtainPair, 'access' | 'refresh'>;
}

export interface ApiJwtTokenRefreshCreateRequest {
  tokenRefresh: Omit<TokenRefresh, 'access'>;
}

/**
 *
 */
export class ApiJwtTokenApi extends runtime.BaseAPI {
  /**
   * Takes a set of user credentials and returns an access and refresh JSON web token pair to prove the authentication of those credentials.
   */
  async apiJwtTokenCreateRaw(
    requestParameters: ApiJwtTokenCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<TokenObtainPair>> {
    if (requestParameters['tokenObtainPair'] == null) {
      throw new runtime.RequiredError(
        'tokenObtainPair',
        'Required parameter "tokenObtainPair" was null or undefined when calling apiJwtTokenCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/api-jwt-token/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: TokenObtainPairToJSON(requestParameters['tokenObtainPair']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => TokenObtainPairFromJSON(jsonValue));
  }

  /**
   * Takes a set of user credentials and returns an access and refresh JSON web token pair to prove the authentication of those credentials.
   */
  async apiJwtTokenCreate(
    requestParameters: ApiJwtTokenCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<TokenObtainPair> {
    const response = await this.apiJwtTokenCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Clear the Django session on logout so session-protected views (e.g. /docs/) correctly deny access after the user logs out of the frontend.  Authentication is not required: clearing a session for an unauthenticated request is a no-op, and requiring auth would block logout when the JWT has just expired (SessionAuthentication would then enforce CSRF which the SPA does not send).
   */
  async apiJwtTokenLogoutCreateRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api-jwt-token/logout/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Clear the Django session on logout so session-protected views (e.g. /docs/) correctly deny access after the user logs out of the frontend.  Authentication is not required: clearing a session for an unauthenticated request is a no-op, and requiring auth would block logout when the JWT has just expired (SessionAuthentication would then enforce CSRF which the SPA does not send).
   */
  async apiJwtTokenLogoutCreate(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
    await this.apiJwtTokenLogoutCreateRaw(initOverrides);
  }

  /**
   * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
   */
  async apiJwtTokenRefreshCreateRaw(
    requestParameters: ApiJwtTokenRefreshCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<TokenRefresh>> {
    if (requestParameters['tokenRefresh'] == null) {
      throw new runtime.RequiredError(
        'tokenRefresh',
        'Required parameter "tokenRefresh" was null or undefined when calling apiJwtTokenRefreshCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/api-jwt-token/refresh/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: TokenRefreshToJSON(requestParameters['tokenRefresh']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => TokenRefreshFromJSON(jsonValue));
  }

  /**
   * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
   */
  async apiJwtTokenRefreshCreate(
    requestParameters: ApiJwtTokenRefreshCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<TokenRefresh> {
    const response = await this.apiJwtTokenRefreshCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
